import {Dayjs} from 'dayjs';

export function getComparisonRange(from: Dayjs, to: Dayjs, period: string) {
    switch (period) {
        case 'previous_month':
            return {from: from.subtract(1, 'month'), to: to.subtract(1, 'month')};
        case 'previous_year':
            return {from: from.subtract(1, 'year'), to: to.subtract(1, 'year')};
        default: {
            const days = Math.max(1, to.diff(from, 'days'));
            return {from: from.subtract(days, 'days'), to: to.subtract(days, 'days')};
        }
    }
}
